import { createSelector } from 'reselect';
import { map } from 'underscore';

export const getProducts = state => state.products.data;

export function getProductsArray(state) {
    return map(getProducts(state), item => item).reverse();
}

export function getProductById(state, id) {
    return getProducts(state)[id];
}

// =====================================
//  MEMOIZED SELECTORS
// -------------------------------------

export const makeGetProductById = () => createSelector(
    getProductById,
    product => product
);



/** WEBPACK FOOTER **
 ** ./src/core/products/productsSelectors.js
 **/